import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import FindCare from "@/pages/FindCare";
import CarerProfile from "@/pages/CarerProfile";
import BecomeCarer from "@/pages/BecomeCarer";
import HowItWorks from "@/pages/HowItWorks";
import TrustSafety from "@/pages/TrustSafety";
import NRI from "@/pages/NRI";
import Auth from "@/pages/Auth";
import SeekerPortal from "@/pages/SeekerPortal";
import CarerPortal from "@/pages/CarerPortal";
import AdminPortal from "@/pages/AdminPortal";
import CheckoutSummary from "@/pages/CheckoutSummary";
import CheckoutPayment from "@/pages/CheckoutPayment";

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen grid place-items-center text-ink-soft">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    const path = user.role === "admin" ? "/admin" : user.role === "carer" ? "/carer" : "/seeker";
    return <Navigate to={path} replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/find-care" element={<FindCare />} />
          <Route path="/carer/:id" element={<CarerProfile />} />
          <Route path="/become-a-carer" element={<BecomeCarer />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/trust-safety" element={<TrustSafety />} />
          <Route path="/nri" element={<NRI />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/seeker" element={<Protected role="care_seeker"><SeekerPortal /></Protected>} />
          <Route path="/checkout/:bookingId" element={<Protected role="care_seeker"><CheckoutSummary /></Protected>} />
          <Route path="/checkout/:bookingId/pay" element={<Protected role="care_seeker"><CheckoutPayment /></Protected>} />
          <Route path="/carer" element={<Protected role="carer"><CarerPortal /></Protected>} />
          <Route path="/admin" element={<Protected role="admin"><AdminPortal /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
